import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { CircularProgress } from '@mui/material'
import LogoShort from 'assets/images/bp-logo-orange.png'

const SLOW_AFTER_MS = 25000

const Container = styled.div`
  display: flex;
  gap: 16px;
  padding: 12px 16px;
  align-items: flex-start;
`

const AvatarWrapper = styled.div`
  margin-top: 4px;
`

const HeaderAvatar = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
  flex-shrink: 0;

  @media (max-width: 768px) {
    width: 28px;
    height: 28px;
  }
`

const TypingBubble = styled.div`
  background-color: #f7f7f8;
  border-radius: 8px;
  padding: 12px 16px;
`

const TypingContent = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 14px;
    color: #3f4453;
  }
`

const BusyText = styled.span`
  font-weight: 600;
  line-height: 1.4;
`

const isGenericStatus = status => !status || /^\s*starting\.*\s*$/i.test(status)

const GuruToolIndicator = ({ status }) => {
  const [elapsed, setElapsed] = useState(0)

  useEffect(() => {
    const startedAt = Date.now()
    const id = setInterval(() => setElapsed(Date.now() - startedAt), 1000)
    return () => clearInterval(id)
  }, [])

  const generic = isGenericStatus(status)
  const slow = elapsed >= SLOW_AFTER_MS

  return (
    <Container>
      <AvatarWrapper>
        <HeaderAvatar src={LogoShort} alt="Guru" />
      </AvatarWrapper>
      <TypingBubble>
        <TypingContent>
          <CircularProgress size={20} sx={{ color: '#f57c00' }} />
          {generic && slow ? (
            <BusyText>
              Guru’s busier than usual right now, so this answer is taking a little longer than
              normal. Thanks for bearing with us.
            </BusyText>
          ) : (
            <span>{generic ? 'Guru is thinking…' : status}</span>
          )}
        </TypingContent>
      </TypingBubble>
    </Container>
  )
}

export default GuruToolIndicator
